module.exports = __webpack_public_path__ + "img/digest.62d881fc.svg";